import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, rdata) {
  return useMemo(() => {
    let { active_tasks, done_tasks, ...rest } = rdata || {}
    return {
      ...rest,
      tasks_tasks: [...(active_tasks || []), ...(done_tasks || [])].sort(
        (a, b) => a.order - b.order
      ),
    }
  }, [rdata])
}
